import { HomeTemplate } from "@/components/Templates";
import { useDashboard } from "@/hooks/useDashboard";
import { useCommission } from "@/hooks/useCommission";

export function DashboardPage() {
  const { canPayDebt } = useCommission();

  const {
    date,
    storeName,
    stats,
    isStatsLoading,
    orders,
    isOrdersLoading,
    isOrdersError,
    trendData,
    growthPercent,
    isTrendLoading,
    quickOrder,
    hasNoShop,
    isOrderCreateBlocked,
    scrollToQuickOrder,
    quickOrderSectionId,
  } = useDashboard();

  return (
    <HomeTemplate
      hasNoShop={hasNoShop}
      commissionLock={{ isOrderCreateBlocked, canPayDebt }}
      welcome={{
        storeName,
        date,
        todaySales: stats.todaySales,
        awaitingPayment: stats.awaitingPayment,
      }}
      quickOrderSectionId={quickOrderSectionId}
      quickOrder={{
        searchQuery: quickOrder.searchQuery,
        onSearchChange: quickOrder.setSearchQuery,
        filteredProducts: quickOrder.filteredProducts,
        cartItems: quickOrder.cartItems,
        totalPrice: quickOrder.totalPrice,
        orderLink: quickOrder.orderLink,
        orderError: quickOrder.orderError,
        isProductsLoading: quickOrder.isProductsLoading,
        isCreatingOrder: quickOrder.isCreatingOrder,
        onAddProduct: quickOrder.addProduct,
        onRemoveProduct: quickOrder.removeProduct,
        onQuantityChange: quickOrder.updateQuantity,
        onCreateOrderLink: quickOrder.createOrderLink,
        onReset: quickOrder.resetOrder,
      }}
      stats={{
        todaySales: stats.todaySales,
        awaitingPayment: stats.awaitingPayment,
        preparing: stats.preparing,
        isLoading: isStatsLoading,
      }}
      latestOrders={{
        orders,
        isLoading: isOrdersLoading,
        isError: isOrdersError,
        onCreateFirstClick: scrollToQuickOrder,
      }}
      trend={{
        data: trendData,
        growthPercent,
        isLoading: isTrendLoading,
      }}
    />
  );
}
